import { Message } from '@/utils/message';
import ClipboardJS from 'clipboard';

export default function useClipboard(t: (key: string) => string, target = '.clip-btn') {
    let ins: ClipboardJS | null = null;

    function install() {
        ins = new ClipboardJS(target);

        ins.on('success', e => {
            const trigger = e.trigger as HTMLElement;
            const toastType = trigger.getAttribute('data-clipboard-toast');

            if (toastType === 'content') {
                const titleKey = trigger.getAttribute('data-clipboard-toast-title') || 'myEvent.copyContentTitle';
                const copiedText = e.text || trigger.getAttribute('data-clipboard-text') || '';
                console.log('copiedText', copiedText);
                Message.copyContent(t(titleKey), copiedText);
                return;
            }

            const successKey = trigger.getAttribute('data-clipboard-success-msg') || 'common.copySuccess';
            Message.success(t(successKey));
        });
    }

    return {
        install,
    };
}
